<kendo-chart (seriesClick)="onSeriesClick($event)">
  <kendo-chart-title text="Daily Access Data For Past Week"> </kendo-chart-title>
  <kendo-chart-tooltip [shared]="true">
    <ng-template kendoChartSharedTooltipTemplate let-category="category" let-points="points">
      <div *ngFor="let point of points">{{ point.series.name }} : {{ point.value | number }}</div>
    </ng-template>
  </kendo-chart-tooltip>
  <kendo-chart-legend position="bottom" orientation="horizontal"> </kendo-chart-legend>
  <kendo-chart-series>
    <kendo-chart-series-item
      *ngFor="let data of dailyAccessData"
      type="column"
      [data]="data.accessData"
      [stack]="{ group: data.type }"
      field="views"
      categoryField="date"
      [name]="data.typeName"
    >
    </kendo-chart-series-item>
  </kendo-chart-series>
</kendo-chart>
